import ServerInstance from "./server.api";

class ManagementEndpoint extends ServerInstance {
    async getManagedProperty() {
        try {
            const response = await this.get("property/managed");
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    async getUtilitiesInvoice() {
        try {
            const responseWater = await this.get("water")
            const responseelectricity = await this.get("electricity")

            return {
                waterInvocie: responseWater.data.received_water_invoice,
                electricityInvocie: responseelectricity.data.received_electricity_invoice,
            }
        } catch (error) {
            throw error
        }
    }

    async verifyUtilityInvoice(invoiceId, type) {
        try {
            const endpoint = type === 'water' ? 'water' : 'electricity';
            const response = await this.patch(`${endpoint}/verify/${invoiceId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default ManagementEndpoint;
